import Flex from '@Components/Bases/Flex';
import DownloadDocument from '@Components/DownloadDocument/DownloadDocument';
import { IReportDetails } from '@Domains/Progress';

import { Box, Typography } from '@mui/material';

type DownloadCVUPProps = { report: IReportDetails };

const DownloadCVUP = (props: DownloadCVUPProps) => {
  const { report } = props;

  const { documentTh, documentEn } = report || {};

  const handleDownloadFileTh = () => {
    if (documentTh) {
      window.open(documentTh, '_blank');
    }
  };

  const handleDownloadFileEn = () => {
    if (documentEn) {
      window.open(documentEn, '_blank');
    }
  };
  return (
    <Box
      p={2}
      bgcolor={'grey.50'}
      maxHeight={'150px'}
      borderRadius={2}
      border={'1px solid rgba(0, 0, 0, 0.12)'}
      justifyContent={'center'}
    >
      <Flex flexDirection="column" gap={0.5}>
        <Typography fontWeight={'bold'} mb={2} fontSize={20}>
          ดาวน์โหลดแผน Corporate Value Up
        </Typography>

        <DownloadDocument
          label="ดาวน์โหลดเอกสาร"
          language="ภาษาไทย"
          disabled={!documentTh}
          onDownload={handleDownloadFileTh}
        />

        <DownloadDocument
          label="ดาวน์โหลดเอกสาร"
          language="ภาษาอังกฤษ"
          disabled={!documentEn}
          onDownload={handleDownloadFileEn}
        />
      </Flex>
    </Box>
  );
};

export default DownloadCVUP;
